import gql from 'graphql-tag';

const getPurchasedCustomPrintRecipientQuery = gql`
  query getPurchasedCustomPrintRecipientQuery($id: RecordID!) {
    purchasedCustomPrint(id: $id) {
      id
      roster_identity_linked_identity_address {
        id
        roster_identity_linked_identity {
          identity {
            id
            name
          }
        }
      }
    }
  }
`;

export default getPurchasedCustomPrintRecipientQuery;
